<template>
  <div>
    <i v-if="value < 0" v-html="$icons.play_red"></i>
    <i v-else-if="value > 0" v-html="$icons.play_green"></i>
    <i v-else>
      <div class="h-3 w-3 rounded-full bg-gray-500"></div>
    </i>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
    },
  },
};
</script>

<style></style>
